<i18n src="@/locales/models/liquidation.yml" lang="yaml"></i18n>
<template>
  <div class="mt-6 flex flex-row">
    <ag-grid-vue
      style="width: 100%; height: 650px"
      class="ag-theme-alpine w-full h-full"
      :columnDefs="columnDefs"
      :defaultColDef="defaultColDef"
      :rowData="weeks"
    >
    </ag-grid-vue>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue3";

export default {
  name: "AELiquidationsQueryByProviderShowProviderCropsizeWeeklyTable",
  components: {
    AgGridVue
  },
  props: {
    data: { required: true },
    crop_size_labels: { required: true }
  },
  data() {
    return {
      defaultColDef: {
        sortable: true,
        filter: true,
        floatingFilter: true
      },
    }
  },
  computed: {
    columnDefs: function () {
      return [
        {
          headerName: this.$t("model.liquidation.month"),
          field: "month",
          filter: true,
          resizable: false,
          pinned: 'left',
        },
        {
          headerName: this.$t("model.liquidation.week"),
          field: "week",
          filter: true,
          resizable: false,
          pinned: 'left',
        },
        {
          headerName: "Exportable",
          field: "ok",
          filter: true,
          resizable: true,
          cellRendererSelector: params => {
            const Cell = {
              template: `<p>{{ numberWithPrecision(${params.value}, 2) }}</p>`
            };
            return { component: Cell }
          }
        },
        {
          headerName: this.$t("model.liquidation.amount_per_package"),
          field: "average_fob",
          filter: true,
          resizable: true,
          cellRendererSelector: params => {
            const Cell = {
              template: `<p>{{ numberWithPrecision(${params.value}, 2) }}</p>`
            };
            return { component: Cell }
          }
        },
        ...this.crop_size_labels.map(crop_size_label => {
          return {
            headerName: `FOB ${crop_size_label}`,
            field: crop_size_label,
            filter: true,
            resizable: true,
            cellRendererSelector: params => {
              const Cell = {
                template: `<p>{{ numberWithPrecision(${params.value}, 2) }}</p>`
              };
              return { component: Cell }
            }
          }
        })
      ]
    },
    weeks: function () {
      let weeks = [];
      for (const [month, data] of Object.entries(this.data)) {
        data.forEach(week => {
          weeks.push({
            month: month,
            ...week,
            ...week.average_fob_by_crop_size
          })
        })
      }
      return weeks.reverse();
    }
  },
};
</script>
